/**
 * @param {HTMLElement} container
 */
function createProductCarousel(container) {
  const DEFAULT_VALUES = {
    slidesPerViewMobile: 2.5,
    slidesPerViewDesktop: 3,
    spaceBetweenMobile: 20,
    spaceBetweenDesktop: 40,
  };

  /** @type {any | null} */
  let swiper = null;
  /** @type {any | null} */
  let handleArrowUpdate = null;

  // LIFECYCLE
  function destroy() {
    if (swiper) {
      if (handleArrowUpdate) {
        swiper.off("activeIndexChange resize", handleArrowUpdate);
        handleArrowUpdate = null;
      }

      swiper.destroy(true, true);
      swiper = null;
    }
  }

  function init() {
    destroy();

    const swiperElement = getSwiperElement();
    if (!swiperElement) {
      return;
    }

    const options = getSwiperOptions(swiperElement);
    swiper = initSwiper(swiperElement, options);
    if (!swiper) {
      return;
    }
  }
  // HELPERS
  function getSwiperElement() {
    const element = container.classList.contains("swiper")
      ? container
      : container.querySelector(".swiper");
    return element instanceof HTMLElement ? element : null;
  }

  /**
   * @param {HTMLElement} swiperElement
   */
  function getSwiperUserOptions(swiperElement) {
    const isLoopEnabled = container.dataset.isLoopEnabled === "true";
    const slidesCount = swiperElement.querySelectorAll(".swiper-slide").length;
    const slidesPerViewMobile =
      Number(container.dataset.slidesPerViewMobile) ||
      DEFAULT_VALUES.slidesPerViewMobile;
    const slidesPerViewDesktop =
      Number(container.dataset.slidesPerViewDesktop) ||
      DEFAULT_VALUES.slidesPerViewDesktop;

    const isLoopAllowedMobile =
      isLoopEnabled && slidesCount > slidesPerViewMobile;
    const isLoopAllowedDesktop =
      isLoopEnabled && slidesCount > slidesPerViewDesktop;
      
    const spaceBetweenMobile =
      container.dataset.spaceBetweenMobile !== undefined
        ? Number(container.dataset.spaceBetweenMobile)
        : DEFAULT_VALUES.spaceBetweenMobile;
    const spaceBetweenDesktop =
      container.dataset.spaceBetweenDesktop !== undefined
        ? Number(container.dataset.spaceBetweenDesktop)
        : DEFAULT_VALUES.spaceBetweenDesktop;

    return {
      autoplay: false,
      loop: isLoopAllowedMobile,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetweenMobile,
      breakpoints: {
        768: {
          loop: isLoopAllowedDesktop,
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop
        },
      },
    };
  }

  /**
   * @param {HTMLElement} swiperElement
   */
  function getSwiperOptions(swiperElement) {
    const userOptions = getSwiperUserOptions(swiperElement);

    return {
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: swiperElement.querySelector(".swiper-button-next"),
        prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      ...userOptions,
    };
  }

  /**
   * @param {HTMLElement} swiperElement
   * @param {any} options
   */
  function initSwiper(swiperElement, options) {
    const SwiperConstructor = /** @type {any} */ (window).Swiper || null;
    if (!SwiperConstructor) {
      console.warn("[ProductCarousel] Swiper is not available");
      return null;
    }

    return new SwiperConstructor(swiperElement, options);
  }

  init();
}

document.addEventListener("DOMContentLoaded", () => {
  const carousels = document
    .querySelectorAll('[id^="swiper-carousel-"]')
    
    if(!carousels.length) {
      return
    }
  
    carousels.forEach((container) => {
      if (
        container instanceof HTMLElement &&
        container.classList.contains("swiper-carousel")
      ) {
        createProductCarousel(container);
      }
    });
});
